/** Сайдбар */

$('.js-sidebar-menu-select').on('change', function () {
    window.location.href = $(this).find(':selected').val();
});


// WEBPACK FOOTER //
// ./_src/js/Sidebar.js